var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('i',{staticClass:"fa-li fa fa-ellipsis-v dropbtn",on:{"click":(event) => _vm.dropdownOption(event)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }